import { IconArrowLeft } from "@tabler/icons-react";
import {
  IconDownload,
  IconFileImport,
  IconPlus,
  IconX,
} from "@tabler/icons-react";
import { useRef } from "react";

function ModeToolHeader({
  onCloseTool,
  selectedMode,
  isPickingModePoints,
  onTogglePickingModePoints,
  onStopWalkingRouteShapeEdit,
  selectedStartPointName,
  languageList = [],
  activeLanguageIso = "",
  onChangeLanguage,
  onImportJson,
  isImportingJson = false,
  onExportJson,
  canExportJson = false,
}) {
  const fileInputRef = useRef(null);

  return (
    <div className="mode-route-tool-header">
      {languageList.length ? (
        <div className="app-language-section">
          <div className="app-language-switcher" aria-label="Languages">
            {languageList.map((language) => (
              <button
                key={language.id || language.iso}
                type="button"
                className={`app-language-btn ${activeLanguageIso === language.iso ? "is-active" : ""}`}
                onClick={(event) => {
                  event.stopPropagation();
                  onChangeLanguage?.(language.iso);
                }}
                aria-pressed={activeLanguageIso === language.iso}
                title={language.name || language.iso.toUpperCase()}
              >
                {language.iso.toUpperCase()}
              </button>
            ))}
          </div>
        </div>
      ) : null}
      <div className="mode-route-tool-head">
        <button
          type="button"
          className="app-icon-btn app-icon-btn--back"
          aria-label="Go back"
          title="Go back"
          onClick={(event) => {
            event.stopPropagation();
            onStopWalkingRouteShapeEdit?.();
            onCloseTool?.();
          }}
        >
          <IconArrowLeft size={16} />
        </button>
        {selectedMode ? (
          <input
            ref={fileInputRef}
            type="file"
            accept=".json,application/json"
            style={{ display: "none" }}
            onChange={(event) => {
              const file = event.target.files?.[0] || null;
              onImportJson?.(file);
              event.target.value = "";
            }}
          />
        ) : null}
        {selectedMode ? (
          <button
            type="button"
            className={`app-icon-btn app-icon-btn--update ${isImportingJson ? "is-loading" : ""}`}
            aria-label="Import Route Type JSON"
            title="Import Route Type JSON"
            disabled={isImportingJson}
            onClick={(event) => {
              event.stopPropagation();
              if (isImportingJson) return;
              onStopWalkingRouteShapeEdit?.();
              fileInputRef.current?.click();
            }}
          >
            {isImportingJson ? (
              <span className="mode-route-tool-btn-spinner" />
            ) : (
              <IconFileImport size={16} />
            )}
          </button>
        ) : null}
        {selectedMode ? (
          <button
            type="button"
            className="app-icon-btn app-icon-btn--update"
            aria-label="Download Route Type JSON"
            title="Download Route Type JSON"
            disabled={!canExportJson || isImportingJson}
            onClick={(event) => {
              event.stopPropagation();
              onStopWalkingRouteShapeEdit?.();
              onExportJson?.();
            }}
          >
            <IconDownload size={16} />
          </button>
        ) : null}
        {selectedMode ? (
          <button
            type="button"
            className="app-icon-btn app-icon-btn--update"
            aria-label={
              isPickingModePoints ? "Cancel add mode point" : "Add mode point"
            }
            title={
              isPickingModePoints ? "Cancel add mode point" : "Add mode point"
            }
            onClick={(event) => {
              event.stopPropagation();
              onStopWalkingRouteShapeEdit?.();
              onTogglePickingModePoints?.();
            }}
          >
            {isPickingModePoints ? <IconX size={16} /> : <IconPlus size={16} />}
          </button>
        ) : null}
        <h3 className="mode-route-tool-title">
          {/* Shows current start-point name next to Mode Tool title. */}
          Route
          {selectedStartPointName ? ` - ${selectedStartPointName}` : ""}
          <p className="mode-route-tool-subtitle">
            {/* Shows active mode name so users know which route type is being edited. */}
            {/* Type -  */}
            {String(selectedMode || "").toLowerCase() === "random"
              ? "Points of Interest"
              : String(selectedMode || "").toLowerCase()}
          </p>
        </h3>
      </div>
    </div>
  );
}

export default ModeToolHeader;
